import React from "react";
import { TrainingCenterBundleDueDateId } from "../../../messages";
import { TrainingCenterBundleCourse } from "../../../system/AppState/AppStateTrainingCenter";
import { List } from "../../../utils/List";
import { CHECK_OUTLINED_ICON, PLAY_OUTLINED_ICON } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";
import { AppList, AppListItem } from "../../Generic/AppList";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import {
  getCourseName,
  isTrainingCenterCourseCompleted,
} from "../../TrainingCenter/TrainingCenterUtils";
import TrainingCenterBundleCourseStatus from "./TrainingCenterBundleCourseStatus";

interface Props {
  bundleDueDateId: TrainingCenterBundleDueDateId;
  courses: List<TrainingCenterBundleCourse>;
  languagePreference: TrainingCenterLanguagePreference;
}

const TrainingCenterBundleCardCoursesList = (props: Props) => {
  const completionPercents = (course: TrainingCenterBundleCourse) => {
    const totalCompleted = course.bundleItems.filter((x) => x.itemCompleted).length;

    return (totalCompleted / course.bundleItems.length) * 100;
  };

  return (
    <AppList className="TrainingCenterBundleCardCoursesList" bordered={true}>
      {props.courses.zipWithIndex().map(([course, i]) => (
        <AppListItem
          key={`course-${i}`}
          leading={
            isTrainingCenterCourseCompleted(course) ? (
              <AppIcon icon={CHECK_OUTLINED_ICON} size={24} />
            ) : (
              <AppIcon icon={PLAY_OUTLINED_ICON} size={24} />
            )
          }
          title={getCourseName(course, props.languagePreference)}
          trailing={<TrainingCenterBundleCourseStatus course={course} />}
          style={{ ["--progress" as any]: `${completionPercents(course)}%` }}
        />
      ))}
    </AppList>
  );
};

export default TrainingCenterBundleCardCoursesList;
